import type { Snapshot } from '@ember-data/legacy-compat/-private';
import CentralMappingMappingEntrySerializer, {
  MAPPING_ENTRY_ATTRS,
} from 'lumen/serializers/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryChannelSerializer extends CentralMappingMappingEntrySerializer {
  attrs = {
    ...MAPPING_ENTRY_ATTRS,
    userCostProfile: 'user_cost_profile_id',
    autoCostProfile: 'auto_cost_profile_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      return super.modelNameFromPayloadKey(
        'central-mapping/mapping-entry-channel',
      );
    }

    return key;
  }

  serialize(snapshot: Snapshot, options: object): Record<string, unknown> {
    const payload = super.serialize(snapshot, options);

    // The backend owns the auto cost profile.
    if ('auto_cost_profile_id' in payload) {
      delete payload['auto_cost_profile_id'];
    }

    return payload;
  }
}
